export default __webpack_public_path__ + "static/media/ic_scroll_left.f77a8fe2.svg";